<!-- prettier-ignore -->

<ion-header>
  <ion-toolbar class="toolbar-360">
    <ion-title>{{'Imagen 360' | translate}}</ion-title>
    <ion-buttons slot="end" (click)="dismissModal()">
      <ion-icon name="close"></ion-icon>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="body-360">
  <div #panorama></div>
</ion-content>
